import React from 'react'
import eastmanLogo from "./images/eastman.webp"; // Replace with actual paths
import dollarLogo from "./images/dollar.webp";
import nathLogo from "./images/nath.webp";
import { Navbar } from 'react-bootstrap';
import NavbarComponent from './navbar';
import Footer from './footer';
import { Helmet } from 'react-helmet';
function Customers() {


  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Toodhu Customers",
    "url": "https://toodhu.com/customers",
    "description": "Explore how Toodhu serves its customers with top-quality products and services. Join our satisfied users and experience the best with Toodhu today!",
    "inLanguage": "en",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Toodhu",
      "url": "https://toodhu.com"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://toodhu.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Customers",
          "item": "https://toodhu.com/customers"
        }
      ]
    },
    "about": {
      "@type": "Organization",
      "name": "Toodhu",
      "url": "https://toodhu.com",
      "description": "Toodhu provides high-quality products and services, ensuring customer satisfaction and business success."
    }
  };


  return (
   <>
   <Helmet>

   <title>Our Happy Customers | Toodhu</title>
<meta charset="utf-8"/>
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Explore how Toodhu serves its customers with top-quality products and services. Join our satisfied users and experience the best with Toodhu today!"/>
<meta name="keywords" content="Toodhu customers, Happy customers, Toodhu reviews"/>
<link rel="canonical" href="https://toodhu.com/customers" />
<meta name="robots" content="index,follow"/>
<meta property="og:title" content="Our Happy Customers | Toodhu"/>
<meta property="og:site_name" content="Toodhu"/>
<meta property="og:url" content="https://toodhu.com/customers"/>
<meta property="og:description" content="Explore how Toodhu serves its customers with top-quality products and services. Join our satisfied users and experience the best with Toodhu today!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image"/>
<meta name="twitter:site" content="https://toodhu.com/customers"/>
<meta name="twitter:title" content="Our Happy Customers | Toodhu"/>
<meta name="twitter:description" content="Explore how Toodhu serves its customers with top-quality products and services. Join our satisfied users and experience the best with Toodhu today!"/>
<meta name="twitter:image" content=""/>

   <script type="application/ld+json">{JSON.stringify(schemaData)}</script>

   </Helmet>
    <div className='Customerssection'>

<div>
  <NavbarComponent/>
</div>


      <h6 className="toodhupricing text-center">TESTIMONIALS</h6>
      <h2 className="perfectplan text-center">Made for Product people</h2>
      <p className="toodhulorem">Choose the perfect solution to streamline your business with Toodhu. Enjoy powerful collaboration, seamless integration, and real-time insights for enhanced productivity.</p>

     <br></br>
     <br></br>
     <br></br>


<div className='container'>
     <div className='row'>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={eastmanLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Likshab</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={nathLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Susan</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={dollarLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Maorgen</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={eastmanLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Likshab</div>
            <div>Director</div>
           </div>
       </div>
     </div>

     <div className='row mt-4'>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={eastmanLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Likshab</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={nathLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Susan</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={dollarLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Maorgen</div>
            <div>Director</div>
           </div>
       </div>
       <div className='col-xl-3 col-lg-3 col-md-6 col-xs-12 customerbox me-3'>
           <img src={eastmanLogo} className='customerlogos'/>
           <div className='customercontent'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit.</div>
           <div className='customerrle'>
            <div>Mr. Likshab</div>
            <div>Director</div>
           </div>
       </div>
     </div>    
</div>


<div className='footersec'>
  <Footer/>
</div>
</div>
   </>

  )
}

export default Customers
